// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-link[data-v-34433436] {\n  font-size: 12px;\n}\n.linkMiddle[data-v-34433436] {\n  padding: 0 8px;\n  color: #dddddd;\n}\n.table-top[data-v-34433436] {\n  margin-top: 20px;\n}\n.pagination[data-v-34433436] {\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
